import { useState } from "react";
import axiosAdmin from "../../api/apiAdmin";
import { errorToast } from "./toastAlerts/ToastAlerts";

/**
 * Download button for an admin export.
 *
 * The exports sit behind the admin login, and a plain link carries no token —
 * which is why they used to be public, customer list included (closed
 * 2026-10-09). The file is fetched through axiosAdmin and handed to the
 * browser instead. `href` is the export's URL as the pages already build it;
 * only the part after /api/ is used, under the admin base.
 */
const AdminDownloadLink = ({ href, filename, className = "", title, children }) => {
  const [busy, setBusy] = useState(false);

  const download = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      const path = href.replace(/^.*?\/api\//, "/");
      const res = await axiosAdmin.get(path, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url;
      a.setAttribute("download", filename);
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      errorToast("ფაილი ვერ ჩამოიტვირთა");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={download}
      disabled={busy}
      title={title}
      className={`${className} disabled:opacity-60`}
    >
      {busy ? "…" : children}
    </button>
  );
};

export default AdminDownloadLink;
